import { render } from "./RicaviSottoprogetto.vue?vue&type=template&id=b14451f6&scoped=true&ts=true"
import script from "./RicaviSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./RicaviSottoprogetto.vue?vue&type=script&lang=ts"

import "./RicaviSottoprogetto.vue?vue&type=style&index=0&id=b14451f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14451f6"]])

export default __exports__